import React from "react";
import classNames from "classnames";
import type { FieldConfig, FieldInputProps } from "formik";
import formStyles from "../../features/MainForm/Form.module.css";
import styles from "./Input.module.css";

interface InputFieldProps extends Partial<HTMLInputElement> {
  label: string;
  getFieldProps: (
    nameOrOptions: string | FieldConfig<any>
  ) => FieldInputProps<any>;
  touched?: { [key: string]: boolean | boolean[] };
  errors?: { [key: string]: string | string[] };
  variant?: "default" | "outlined" | "filled";
}

export const InputField: React.FC<InputFieldProps> = ({
  label,
  id,
  autofocus = false,
  name = "input",
  type = "text",
  placeholder = "",
  disabled,
  getFieldProps,
  touched,
  errors,
  variant = "default",
}) => {
  const inputClass = classNames(styles.inputField, {
    [styles.inputFieldOutlined]: variant === "outlined",
    [styles.inputFieldFilled]: variant === "filled",
    [styles.inputFieldError]: touched?.[name] && errors?.[name],
  });

  return (
    <div className={formStyles.formGroup}>
      <label
        htmlFor={id}
        className={classNames({
          [formStyles.labelGroup]: !disabled,
          [formStyles.labelGroupDisabled]: disabled,
        })}
      >
        {label}
      </label>
      <input
        id={id}
        type={type}
        disabled={disabled}
        autoFocus={autofocus}
        placeholder={placeholder}
        className={inputClass}
        {...getFieldProps(name)}
      />

      {touched?.[name] && errors?.[name] && (
        <span className={styles.inputFieldErrorIcon}>X</span>
      )}

      {touched?.[name] && errors?.[name] && (
        <p className={formStyles.formError}>{errors[name]}</p>
      )}
    </div>
  );
};
